import { render, staticRenderFns } from "./GatewayProcessState.vue?vue&type=template&id=2b389510&"
import script from "./GatewayProcessState.vue?vue&type=script&lang=js&"
export * from "./GatewayProcessState.vue?vue&type=script&lang=js&"
import style0 from "./GatewayProcessState.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports